import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import {
  $DCprimaryColor,
  ButtonsGroup,
  DcButton,
  PixelCheckboxGroup,
  PixelDate,
  PixelDropDown,
  PixelFactoryContext,
  PixelIcon,
  PixelInput,
  PixelModal,
  PixelPageContainer,
  PixelTag,
  PixelTooltip,
} from 'pixel-base'
import styled from 'styled-components'

import {
  createCourierComplaint,
  getDiscrepantDetails,
  resolveDiscrepancy,
} from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../../../decl.d'

const DiscrepancyDetails = (props) => {
  const { filters, detailId, updateData } = props
  const { showLoader, hideLoader, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [loading, setLoading] = React.useState(true)
  const [details, setDetails] = React.useState<any>({})
  const [showResolvePopup, setShowResolvePopup] = React.useState(false)
  const [formType, setFormType] = React.useState('1')
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [formData, setFormData] = React.useState({
    remarks: '',
    status: '',
    message: '',
  })
  const [navigationProcess, setnavigationProcess] = React.useState({
    nextId: null,
    prevId: null,
    total_orders: 0,
    curr_order: 0,
  })
  const navigate = useNavigate()
  const loadingSection = React.useRef(null)
  const resolveSection = React.useRef(null)
  useEffect(() => {
    if (detailId) getDetails()
  }, [detailId])
  const getDetails = () => {
    setLoading(true)
    showLoader(loadingSection)
    getDiscrepantDetails(detailId, filters).subscribe((res: any) => {
      setnavigationProcess({
        nextId: res?.response?.data?._meta?.next,
        prevId: res?.response?.data?._meta?.previous,
        total_orders: res?.response?.data?._meta?.total_orders,
        curr_order: res?.response?.data?._meta?.current,
      })
      setDetails(res.response.data)
    })
  }

  React.useEffect(() => {
    if (Object.keys(details).length > 0) {
      setLoading(false)
      hideLoader(loadingSection)
    }
  }, [details])

  const teamComments = details?.comments?.filter(
    (c) => c['comment_type_id'] !== 4,
  )
  const courierUpdates = details?.comments?.filter(
    (c) => c['comment_type_id'] === 4,
  )

  const handleSubmitResolve = (e, type) => {
    e.preventDefault()
    showLoader(resolveSection)
    if (type === 'resolve') {
      const data = {
        transaction_id: details?.status['transaction_id'],
        courier_id: details?.status['courier_id'],
        resolution_status: formData.status,
        remarks: formData.remarks,
      }
      resolveDiscrepancy(details.status.order_id, data).subscribe(
        (res: any) => {
          hideLoader(resolveSection)

          if (res.response.data) {
            updateData(res.response.data)
          } else {
            if (res.response.error && res.response.error.field) {
              setError(res.response.error)
            } else {
              showFailure(res.response.error)
            }
          }
        },
      )
    } else {
      const data = {
        transaction_id: details?.status['transaction_id'],
        courier_id: details?.status['courier_id'],
        remarks: formData.message,
      }
      createCourierComplaint(details.status.order_id, data).subscribe(
        (res: any) => {
          hideLoader(resolveSection)

          if (res.response.data) {
            updateData(res.response.data)
            const today = new Date()
            const date = `${today.getFullYear()}-${
              today.getMonth() + 1
            }-${today.getDate()}`
            const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
            const dateTime = `${date}  ${time}`
            const user = JSON.parse(localStorage.getItem('user_info') || '{}')
            const commentData = {
              comment_type_id: 1,
              comment_time: dateTime,
              order_comment: `Courier complaint created: ${formData.message}`,
              name: user?.name,
            }
            setDetails({
              ...details,
              comments: [commentData, ...details.comments],
            })
          } else {
            if (res.response.error && res.response.error.field) {
              setError(res.response.error)
            } else {
              showFailure(res.response.error)
            }
          }
        },
      )
    }
    setTimeout(() => {
      location.reload()
    }, 2000)
  }

  return (
    <>
      <PixelPageContainer>
        <DetailContainer>
          <Header>
            <HeaderContainerLeft>
              <HeaderTitle>Discrepancy Details</HeaderTitle>
            </HeaderContainerLeft>
            <HeaderContainerRight>
              <DcButton
                variant="outline-success"
                size="sm"
                onClick={() => {
                  setShowResolvePopup(true)
                }}
              >
                <ButtonLink>Resolve</ButtonLink>
              </DcButton>
              <ButtonsGroup
                style={{
                  gap: '15px',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
              >
                <PixelTooltip tooltipText="Previous">
                  <DcButton
                    disabled={navigationProcess.prevId === null}
                    onClick={() => {
                      navigate(
                        `/payments/discrepant-details?id=${navigationProcess.prevId}&courier_id=${p?.courier_id}&start_date=${p?.start_date}&end_date=${p?.end_date}&page=${p?.page}&reconcile_status=${p?.reconcile_status}`,
                      )
                    }}
                    size="sm"
                    variant="outline-primary"
                  >
                    <PixelIcon color="inherit" icon={faChevronLeft} />
                  </DcButton>
                </PixelTooltip>
                <OrderPage>
                  {navigationProcess.curr_order}/
                  {navigationProcess.total_orders}
                </OrderPage>
                <PixelTooltip tooltipText="Next">
                  <DcButton
                    disabled={navigationProcess.nextId === null}
                    onClick={() => {
                      navigate(
                        `/payments/discrepant-details?id=${navigationProcess.nextId}&courier_id=${p?.courier_id}&start_date=${p?.start_date}&end_date=${p?.end_date}&page=${p?.page}&reconcile_status=${p?.reconcile_status}`,
                      )
                    }}
                    size="sm"
                    variant="outline-primary"
                  >
                    <PixelIcon icon={faChevronRight} />
                  </DcButton>
                </PixelTooltip>
              </ButtonsGroup>
            </HeaderContainerRight>
          </Header>

          {loading ? (
            <LoadingSection
              className="loading-section"
              ref={loadingSection}
            ></LoadingSection>
          ) : (
            <DiscrepancyTable>
              <tr>
                <DiscrepancyTh colSpan={4}>Order Information</DiscrepancyTh>
              </tr>
              <tr>
                <DiscrepancyHeadTd>Order Id</DiscrepancyHeadTd>
                <DiscrepancyHeadTd colSpan={2}>Tracking Id</DiscrepancyHeadTd>
                <DiscrepancyHeadTd>PixelOne Reference</DiscrepancyHeadTd>
              </tr>
              <tr>
                <DiscrepancyTd>
                  {details?.status?.source_order_id
                    ? details?.status?.source_order_id
                    : '--'}
                </DiscrepancyTd>
                <DiscrepancyTd colSpan={2}>
                  {details?.status?.tracking_id
                    ? details?.status?.tracking_id
                    : '--'}
                </DiscrepancyTd>
                <DiscrepancyTd>
                  {details?.status?.order_id ? details?.status?.order_id : '--'}
                </DiscrepancyTd>
              </tr>
              <tr>
                <DiscrepancyTh colSpan={4}>
                  Reconciliation Information
                </DiscrepancyTh>
              </tr>
              <tr>
                <DiscrepancyHeadTd rowSpan={2}>Order Status</DiscrepancyHeadTd>
                <DiscrepancyTd>PixelOne</DiscrepancyTd>
                <DiscrepancyTd>Courier</DiscrepancyTd>
                <DiscrepancyTd>Reconciled</DiscrepancyTd>
              </tr>
              <tr>
                <DiscrepancyTd>
                  {details?.status?.ems_order_status ? (
                    <PixelTag>{details?.status?.ems_order_status}</PixelTag>
                  ) : (
                    '--'
                  )}
                </DiscrepancyTd>
                <DiscrepancyTd>
                  {details?.status?.delivery_status ? (
                    <PixelTag>{details?.status?.delivery_status}</PixelTag>
                  ) : (
                    '--'
                  )}
                </DiscrepancyTd>
                <DiscrepancyTd>
                  {details?.status?.delivery_reconcile_status ===
                  'reconciled' ? (
                    <SpanTick>&#10003;</SpanTick>
                  ) : (
                    <SpanCross>&#9587;</SpanCross>
                  )}
                </DiscrepancyTd>
              </tr>
              <tr>
                <DiscrepancyHeadTd>Total Order Amount</DiscrepancyHeadTd>
                <DiscrepancyTd>
                  {details?.status?.total ? details?.status?.total : '--'}
                </DiscrepancyTd>
                <DiscrepancyTd>
                  {details.payment?.length !== 0 ? (
                    <DiscrepancyTable>
                      <tr>
                        <DiscrepancyTh colSpan={3}>Payment info</DiscrepancyTh>
                      </tr>
                      <tr>
                        <DiscrepancyHeadTdNested>
                          Reference
                        </DiscrepancyHeadTdNested>
                        <DiscrepancyHeadTdNested>
                          COD Received
                        </DiscrepancyHeadTdNested>
                        <DiscrepancyHeadTdNested>
                          Shipping Charges
                        </DiscrepancyHeadTdNested>
                      </tr>
                      {details.payment?.map(
                        (p, i) =>
                          (p.cod_amount || p.shipping_chg) && (
                            <tr key={i}>
                              <DiscrepancyTdNested>
                                {p.payment_period || '--'}
                              </DiscrepancyTdNested>
                              <DiscrepancyTdNested>
                                {p.cod_amount || '--'}
                              </DiscrepancyTdNested>
                              <DiscrepancyTdNested>
                                {p.shipping_chg || '--'}
                              </DiscrepancyTdNested>
                            </tr>
                          ),
                      )}
                    </DiscrepancyTable>
                  ) : (
                    <div>No Payments Found</div>
                  )}
                </DiscrepancyTd>
                <DiscrepancyTd>
                  {/* <PixelTag>{details?.status?.payment_reconcile_status}</PixelTag> */}
                  {details?.status?.payment_reconcile_status ===
                  'reconciled' ? (
                    <SpanTick>&#10003;</SpanTick>
                  ) : (
                    <SpanCross>&#9587;</SpanCross>
                  )}
                </DiscrepancyTd>
              </tr>
              <tr>
                <DiscrepancyTh colSpan={2}>Team Comments</DiscrepancyTh>
                <DiscrepancyTh colSpan={2}>Courier Updates</DiscrepancyTh>
              </tr>
              <tr>
                <DiscrepancyTd style={{ verticalAlign: 'initial' }} colSpan={2}>
                  <DetailsContentSection>
                    <DetailsContentInnerInfo isColumn>
                      {teamComments.length !== 0 ? (
                        teamComments.map((comment, i) => (
                          <DetailsContentInfo key={i}>
                            <SpanDate title={comment['comment_time']}>
                              <PixelDate
                                value={comment['comment_time']}
                                format={'pixelStandard'}
                              />
                            </SpanDate>
                            -
                            <DetailsContentInfoLabel>
                              {comment['name']}
                            </DetailsContentInfoLabel>
                            <DetailsContentInfoValue>
                              {comment['order_comment']}
                            </DetailsContentInfoValue>
                          </DetailsContentInfo>
                        ))
                      ) : (
                        <DetailsContentInfoNoData>
                          No Comments
                        </DetailsContentInfoNoData>
                      )}
                    </DetailsContentInnerInfo>
                  </DetailsContentSection>
                </DiscrepancyTd>

                <DiscrepancyTd style={{ verticalAlign: 'initial' }} colSpan={2}>
                  <DetailsContentSection>
                    <DetailsContentInnerInfo isColumn>
                      {courierUpdates.length !== 0 ? (
                        courierUpdates.map((comment, i) => (
                          <DetailsContentInfo key={i}>
                            <SpanDate title={comment['comment_time']}>
                              <PixelDate
                                value={comment['comment_time']}
                                format={'pixelStandard'}
                              />
                            </SpanDate>
                            -
                            <DetailsContentInfoLabel>
                              {comment['name']}
                            </DetailsContentInfoLabel>
                            <DetailsContentInfoValue>
                              {comment['order_comment']}
                            </DetailsContentInfoValue>
                          </DetailsContentInfo>
                        ))
                      ) : (
                        <DetailsContentInfoNoData>
                          No Updates
                        </DetailsContentInfoNoData>
                      )}
                    </DetailsContentInnerInfo>
                  </DetailsContentSection>
                </DiscrepancyTd>
              </tr>
            </DiscrepancyTable>
          )}
        </DetailContainer>
      </PixelPageContainer>

      {showResolvePopup && (
        <PixelModal
          title={'Resolve'}
          handleClose={() => setShowResolvePopup(false)}
          show={showResolvePopup}
        >
          {showResolvePopup && (
            <DetailsContentSection
              className="resolveSection"
              ref={resolveSection}
            >
              <DetailsContentInnerInfo isColumn>
                <DetailsContentInfoLabel>
                  Select resolution type:
                </DetailsContentInfoLabel>
                <PixelCheckboxGroup
                  label=""
                  options={[
                    {
                      label: 'Resolve',
                      value: '1',
                      type: 'radio',
                      checked: formType == '1',
                    },
                    {
                      label: 'Lodge a courier complaint',
                      value: '2',
                      type: 'radio',
                      checked: formType == '2',
                    },
                  ]}
                  onChange={(e) => {
                    setFormType(e.target.value)
                  }}
                />
                {formType == '1' ? (
                  <>
                    <Form onSubmit={(e) => handleSubmitResolve(e, 'resolve')}>
                      <FormGroup>
                        <PixelInput
                          error={
                            error.field === 'remarks' && error.error !== ''
                              ? error.error
                              : null
                          }
                          required
                          type={'text'}
                          name={'Remarks'}
                          placeholder={'Remarks'}
                          value={formData.remarks}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              remarks: e.target.value,
                            })
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <PixelDropDown
                          error={
                            error.field === 'status' && error.error !== ''
                              ? error.error
                              : null
                          }
                          required
                          options={[
                            {
                              label: 'Select Resolution Status',
                              value: '',
                            },
                            { value: 'delivered', label: 'Delivered' },
                            { value: 'cancelled', label: 'Cancelled' },
                            { value: 'returned', label: 'Returned' },
                            {
                              value: 'return-received',
                              label: 'Return Recieved',
                            },
                            { value: 'refunded', label: 'Refunded' },
                          ]}
                          value={formData.status}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              status: e.target.value,
                            })
                          }}
                        />
                      </FormGroup>
                      <FormGroup>
                        <DcButton type={'submit'} size="sm">
                          Resolve
                        </DcButton>
                      </FormGroup>
                    </Form>
                  </>
                ) : (
                  <>
                    <Form onSubmit={(e) => handleSubmitResolve(e, 'complaint')}>
                      <FormGroup>
                        <PixelInput
                          error={
                            error.field === 'message' && error.error !== ''
                              ? error.error
                              : null
                          }
                          required
                          type={'textarea'}
                          as={'textarea'}
                          name={'message'}
                          placeholder={'Message'}
                          value={formData.message}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              message: e.target.value,
                            })
                          }
                        />
                      </FormGroup>

                      <FormGroup>
                        <DcButton type={'submit'} size="sm">
                          Send
                        </DcButton>
                      </FormGroup>
                    </Form>
                  </>
                )}
              </DetailsContentInnerInfo>
            </DetailsContentSection>
          )}
        </PixelModal>
      )}
    </>
  )
}

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  transition: all 0.3s ease-in-out;
  margin: 0 auto;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem;
  width: 97%;
`

const HeaderTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #202223;
`

const HeaderContainerLeft = styled.div``
const HeaderContainerRight = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
`

const ButtonLink = styled.a`
  color: inherit !important;
`

const DetailsContentSection = styled.div`
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  min-height: 100px;
`

const DetailsContentInnerInfo = styled.div<{ isColumn?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.isColumn ? 'column' : 'row')};
  justify-content: flex-start;
  align-items: ${(props) => (props.isColumn ? 'flex-start' : 'start')};
  gap: 10px;
`
const DetailsContentInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 5px;
`

const DetailsContentInfoNoData = styled(DetailsContentInfo)`
  margin: auto;
`

const DetailsContentInfoLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: black;
`
const DetailsContentInfoValue = styled.div`
  font-size: 12px;
  font-weight: normal;
  width: 220px;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const LoadingSection = styled.div`
  width: 100%;
  min-height: 400px;
`

const DiscrepancyTable = styled.table`
  border-collapse: collapse;
  width: 97%;
  font-size: 14px;
`

const DiscrepancyTh = styled.td`
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
  font-weight: bold;
  color: black;
  background-color: rgb(227 229 230);
`

const DiscrepancyHeadTd = styled.td`
  border: 1px solid #dddddd;
  text-align: center;
  padding: 5px;
  color: rgb(0 0 0 / 77%);
  font-weight: bold;
  background-color: white;
`

const DiscrepancyHeadTdNested = styled(DiscrepancyHeadTd)`
  font-size: 11px;
`

const DiscrepancyTd = styled.td`
  border: 1px solid #dddddd;
  text-align: center;
  padding: 5px;
  color: rgba(0, 0, 0, 0.54);
  font-weight: bold;
  font-size: 14px;
  background-color: white;
`

const DiscrepancyTdNested = styled(DiscrepancyTd)`
  font-size: 11px;
`

const SpanTick = styled.span`
  color: green;
`

const SpanCross = styled.span`
  color: red;
`

const SpanDate = styled.span`
  font-size: 11px;
`

const OrderPage = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${$DCprimaryColor};
`

export default DiscrepancyDetails
